import React from "react";

const PadelTennisMatchDetails = ({ matches, userNames, styles }) => {
  // Helper function to get player name
  const getPlayerName = (playerId) => {
    if (!playerId) return "Not Selected";
    if (playerId === "guest") return "Guest Player";
    return userNames[playerId] || `Player ${playerId}`;
  };

  return matches.map((match, matchIndex) => (
    <div key={matchIndex} style={{ marginBottom: "clamp(18px, 4vw, 25px)" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "clamp(15px, 4vw, 20px)",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <h4
          style={{
            color: "#2c3e50",
            margin: 0,
            fontSize: "clamp(16px, 3.5vw, 20px)",
          }}
        >
          Match #{matchIndex + 1}
        </h4>
        <span
          style={{
            backgroundColor:
              match.winner === "user"
                ? "#27ae60"
                : match.winner === "opponent"
                ? "#e74c3c"
                : "#95a5a6",
            color: "white",
            padding: "clamp(3px, 1vw, 4px) clamp(10px, 2.5vw, 12px)",
            borderRadius: "20px",
            fontSize: "clamp(11px, 2.2vw, 12px)",
            fontWeight: "600",
          }}
        >
          {match.winner === "user"
            ? "WIN"
            : match.winner === "opponent"
            ? "LOSS"
            : "IN PROGRESS"}
        </span>
      </div>

      {/* Team Display */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          gap: "clamp(12px, 4vw, 20px)",
          alignItems: "center",
          backgroundColor: "#f8f9fa",
          padding: "clamp(15px, 5vw, 25px)",
          borderRadius: "12px",
          marginBottom: "clamp(15px, 4vw, 20px)",
          border: "2px solid #e9ecef",
        }}
      >
        {/* Team A */}
        <div style={{ textAlign: "center" }}>
          <h3
            style={{
              color: "#2c3e50",
              margin: "0 0 clamp(10px, 3vw, 15px) 0",
              fontSize: "clamp(16px, 3.5vw, 20px)",
            }}
          >
            Team A
          </h3>
          <div
            style={{
              fontSize: "clamp(32px, 8vw, 42px)",
              fontWeight: "bold",
              color: "#27ae60",
              marginBottom: "clamp(8px, 2vw, 10px)",
            }}
          >
            {match.userSets}
          </div>
          <div
            style={{
              fontSize: "clamp(11px, 2.2vw, 12px)",
              color: "#6c757d",
              marginBottom: "clamp(10px, 3vw, 15px)",
            }}
          >
            Sets Won
          </div>

          <div
            style={{
              backgroundColor: "white",
              padding: "clamp(10px, 3vw, 15px)",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                marginBottom: "8px",
                fontSize: "clamp(12px, 2.5vw, 14px)",
                fontWeight: "500",
              }}
            >
              👤 {getPlayerName(match.teamA?.player1)}
            </div>
            <div
              style={{
                fontSize: "clamp(12px, 2.5vw, 14px)",
                fontWeight: "500",
              }}
            >
              👤 {getPlayerName(match.teamA?.player2)}
            </div>
          </div>
        </div>

        {/* VS */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "clamp(18px, 5.5vw, 28px)",
            fontWeight: "bold",
            color: "#6c757d",
            padding: "0 clamp(10px, 4vw, 20px)",
          }}
        >
          VS
        </div>

        {/* Team B */}
        <div style={{ textAlign: "center" }}>
          <h3
            style={{
              color: "#2c3e50",
              margin: "0 0 clamp(10px, 3vw, 15px) 0",
              fontSize: "clamp(16px, 3.5vw, 20px)",
            }}
          >
            Team B
          </h3>
          <div
            style={{
              fontSize: "clamp(32px, 8vw, 42px)",
              fontWeight: "bold",
              color: "#e74c3c",
              marginBottom: "clamp(8px, 2vw, 10px)",
            }}
          >
            {match.opponentSets}
          </div>
          <div
            style={{
              fontSize: "clamp(11px, 2.2vw, 12px)",
              color: "#6c757d",
              marginBottom: "clamp(10px, 3vw, 15px)",
            }}
          >
            Sets Won
          </div>

          <div
            style={{
              backgroundColor: "white",
              padding: "clamp(10px, 3vw, 15px)",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                marginBottom: "8px",
                fontSize: "clamp(12px, 2.5vw, 14px)",
                fontWeight: "500",
              }}
            >
              👤 {getPlayerName(match.teamB?.player1)}
            </div>
            <div
              style={{
                fontSize: "clamp(12px, 2.5vw, 14px)",
                fontWeight: "500",
              }}
            >
              👤 {getPlayerName(match.teamB?.player2)}
            </div>
          </div>
        </div>
      </div>

      {/* Match Info */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          gap: "clamp(12px, 3vw, 15px)",
          marginBottom: "clamp(15px, 4vw, 20px)",
          fontSize: "clamp(13px, 2.5vw, 15px)",
        }}
      >
        <p>
          <strong>Match Type:</strong> {match.matchType || "Best of 3"}
        </p>
        <p>
          <strong>Sets Played:</strong> {match.sets?.length || 0}
        </p>
        <p>
          <strong>Format:</strong> Doubles (4 players)
        </p>
        <p>
          <strong>Game Mode:</strong> {match.gameMode || "doubles"}
        </p>
      </div>

      {/* Set Details */}
      {match.sets && match.sets.length > 0 && (
        <div style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
          <h4
            style={{
              color: "#2c3e50",
              marginBottom: "clamp(12px, 3vw, 15px)",
              fontSize: "clamp(15px, 3vw, 18px)",
            }}
          >
            🎾 Set by Set Breakdown
          </h4>
          <table style={styles.setsTable}>
            <thead>
              <tr>
                <th style={styles.tableTh}>Set</th>
                <th style={styles.tableTh}>Team A Games</th>
                <th style={styles.tableTh}>Team B Games</th>
                <th style={styles.tableTh}>Team A Tiebreak</th>
                <th style={styles.tableTh}>Team B Tiebreak</th>
                <th style={styles.tableTh}>Set Winner</th>
              </tr>
            </thead>
            <tbody>
              {match.sets.map((set, index) => {
                let setWinner = "incomplete";
                if (
                  set.userGames >= 6 &&
                  set.userGames >= set.opponentGames + 2
                ) {
                  setWinner = "teamA";
                } else if (
                  set.userGames === 7 &&
                  set.opponentGames === 6 &&
                  set.userTiebreak > set.opponentTiebreak
                ) {
                  setWinner = "teamA";
                } else if (
                  set.opponentGames >= 6 &&
                  set.opponentGames >= set.userGames + 2
                ) {
                  setWinner = "teamB";
                } else if (
                  set.opponentGames === 7 &&
                  set.userGames === 6 &&
                  set.opponentTiebreak > set.userTiebreak
                ) {
                  setWinner = "teamB";
                }

                return (
                  <tr
                    key={index}
                    style={{
                      backgroundColor:
                        setWinner === "teamA"
                          ? "#d4edda"
                          : setWinner === "teamB"
                          ? "#f8d7da"
                          : "transparent",
                    }}
                  >
                    <td style={styles.tableTd}>Set {index + 1}</td>
                    <td style={styles.tableTd}>
                      <strong>{set.userGames}</strong>
                      {setWinner === "teamA" && " 🏆"}
                    </td>
                    <td style={styles.tableTd}>
                      <strong>{set.opponentGames}</strong>
                      {setWinner === "teamB" && " 🏆"}
                    </td>
                    <td style={styles.tableTd}>{set.userTiebreak || "—"}</td>
                    <td style={styles.tableTd}>
                      {set.opponentTiebreak || "—"}
                    </td>
                    <td style={styles.tableTd}>
                      <span
                        style={{
                          color:
                            setWinner === "teamA"
                              ? "#27ae60"
                              : setWinner === "teamB"
                              ? "#e74c3c"
                              : "#6c757d",
                          fontWeight: "bold",
                        }}
                      >
                        {setWinner === "teamA"
                          ? "Team A"
                          : setWinner === "teamB"
                          ? "Team B"
                          : "Incomplete"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Match Summary */}
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          marginBottom: "15px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        }}
      >
        <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
          🏆 Match Summary
        </h4>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            gap: "15px",
          }}
        >
          <div>
            <strong>Overall Winner:</strong>{" "}
            <span
              style={{
                color:
                  match.winner === "user"
                    ? "#27ae60"
                    : match.winner === "opponent"
                    ? "#e74c3c"
                    : "#6c757d",
                fontWeight: "bold",
              }}
            >
              {match.winner === "user"
                ? "Team A"
                : match.winner === "opponent"
                ? "Team B"
                : "In Progress"}
            </span>
          </div>
          <div>
            <strong>Total Sets:</strong> {match.sets?.length || 0}
          </div>
          <div>
            <strong>Sets Score:</strong> {match.userSets} - {match.opponentSets}
          </div>
        </div>
      </div>

      {/* Padel Scoring Info */}
      <div
        style={{
          backgroundColor: "#e6f7ff",
          padding: "15px",
          borderRadius: "8px",
          marginTop: "15px",
          fontSize: "14px",
          color: "#0070f3",
          border: "1px solid #91d5ff",
        }}
      >
        <strong>Padel Tennis Scoring:</strong> Best of 3 sets. First to 6 games
        (must win by 2), or 7-6 with tiebreak. Padel is always played in doubles
        format with 4 players total.
      </div>
    </div>
  ));
};

export default PadelTennisMatchDetails;
